<div *ngIf="prodType=='G'">
    <div class="basicrow mbott">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-i">
                <div class="boxtbl">
                    <div class="basicrow m-sides">
                        <div class="b-title noline">
                            <div class="autocont f-black roboto-l f-bmed pull-left vcenter">
                                <div class="tabcell">
                                    Consumo de Voz
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-tbar">
                        <div class="frwds frths rline trds vcenter">
                            <div class="tabcell">
                                Consumo de Voz
                            </div>
                        </div>
                        <div class="frwds frths rline trds vcenter">
                            <div class="tabcell">
                                Larga Distancia
                            </div>
                        </div>
                        <div class="frwds frths trds vcenter">
                            <div class="tabcell">
                                Larga Distancia Internacional
                            </div>
                        </div>
                    </div>
                    <div class="basicrow">
                        <div class="tab-cbar h-def-i topgbrd">
                            <div class="frwds trds rline vcenter">
                                <div class="tabcell">
                                    <span class="roboto-b">Minutos Usados</span><br />
                                    <span class="f-red f-big line-h-i roboto-b">
                                        {{useminvoice}}
                                    </span>
                                </div>
                            </div>
                            <div class="frwds trds rline vcenter">
                                <div class="tabcell">
                                    <span class="roboto-b">Minutos Usados</span><br />
                                    <span class="f-red f-big line-h-i roboto-b">
                                        {{useminLD}}
                                    </span>
                                </div>
                            </div>
                            <div class="frwds trds vcenter">
                                <div class="tabcell">
                                    <span class="roboto-b">Minutos Usados</span><br />
                                    <span class="f-red f-big line-h-i roboto-b">
                                        {{useminLDI}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-i">
                <div class="boxtbl">
                    <div class="basicrow m-sides">
                        <div class="b-title noline">
                            <div class="autocont f-black roboto-l f-bmed pull-left vcenter">
                                <div class="tabcell">
                                    Consumo de Mensajer&iacute;a
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-tbar">
                        <div class="frwds frths rline trds vcenter">
                            <div class="tabcell">
                                Consumo de SMS/MMS
                            </div>
                        </div>
                        <div class="frwds frths rline trds vcenter">
                            <div class="tabcell">
                                SMS Premium
                            </div>
                        </div>
                        <div class="frwds frths trds vcenter">
                            <div class="tabcell">
                                MMS
                            </div>
                        </div>
                    </div>
                    <div class="basicrow">
                        <div class="tab-cbar h-def-i topgbrd">
                            <div class="frwds trds rline vcenter">
                                <div class="tabcell">
                                    <span class="roboto-b">Usados</span><br />
                                    <span class="f-red f-big line-h-i roboto-b">
                                        {{smsmms}}
                                    </span>
                                </div>
                            </div>
                            <div class="frwds trds rline vcenter">
                                <div class="tabcell">
                                    <span class="roboto-b">Usados</span><br />
                                    <span class="f-red f-big line-h-i roboto-b">
                                        {{smsprem}}
                                    </span>
                                </div>
                            </div>
                            <div class="frwds trds vcenter">
                                <div class="tabcell">
                                    <span class="roboto-b">Usados</span><br />
                                    <span class="f-red f-big line-h-i roboto-b">
                                        {{mms}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="basicrow">
        <div class="logline full"></div>
    </div>
    <div class="basicrow m-top-i m-bott-ii">
        <div class="caja-compra">
            <a class="btns blue vcenter">
                <span class="tabcell">
                    Compra de Paquetes Adicionales&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>
</div>
<div *ngIf="prodType=='O'">
    <div class="basicrow mbott">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-top-i">
                <div class="boxtbl">
                    <div class="basicrow m-sides">
                        <div class="b-title noline">
                            <div class="autocont f-black roboto-l f-bmed pull-left vcenter">
                                <div class="tabcell">
                                    Consumo de Voz
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-tbar">
                        <div class="frwds frths rline trds vcenter">
                            <div class="tabcell">
                                Consumo de Voz
                            </div>
                        </div>
                        <div class="frwds frths rline trds vcenter">
                            <div class="tabcell">
                                Larga Distancia
                            </div>
                        </div>
                        <div class="frwds frths trds vcenter">
                            <div class="tabcell">
                                Larga Distancia Internacional
                            </div>
                        </div>
                    </div>
                    <div class="basicrow">
                        <div class="tab-cbar h-def-i topgbrd">
                            <div class="frwds trds rline vcenter">
                                <div class="tabcell">
                                    <span class="roboto-b">Minutos Usados</span><br />
                                    <span class="f-red f-big line-h-i roboto-b">
                                        {{useminvoice}}
                                    </span>
                                </div>
                            </div>
                            <div class="frwds trds rline vcenter">
                                <div class="tabcell">
                                    <span class="roboto-b">Minutos Usados</span><br />
                                    <span class="f-red f-big line-h-i roboto-b">
                                        {{useminLD}}
                                    </span>
                                </div>
                            </div>
                            <div class="frwds trds vcenter">
                                <div class="tabcell">
                                    <span class="roboto-b">Minutos Usados</span><br />
                                    <span class="f-red f-big line-h-i roboto-b">
                                        {{useminLDI}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="basicrow">
        <div class="logline full"></div>
    </div>
    <div class="basicrow m-top-i m-bott-ii">
        <div class="caja-compra">
            <a routerLink="/datapurchase" class="btns blue vcenter">
                <span class="tabcell">
                    Compra de Paquetes Adicionales&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>
</div>